var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterTagSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27340",
    "data-name": "Group 27340",
    transform: "translate(8715 -9975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6211",
    "data-name": "Rectangle 6211",
    transform: "translate(-8715 9975)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_52",
    "data-name": "Union 52",
    d: "M-15395.866-24777.449l-3.484-3.49a2.214,2.214,0,0,1,0-3.131l6.278-6.277a2.182,2.182,0,0,1,1.567-.652h3.839a1.873,1.873,0,0,1,1.866,1.871v3.834a2.182,2.182,0,0,1-.653,1.566l-6.277,6.279a2.182,2.182,0,0,1-1.568.652A2.2,2.2,0,0,1-15395.866-24777.449Zm3.708-11.984-6.277,6.277a.9.9,0,0,0-.274.654.911.911,0,0,0,.274.652l3.49,3.484a.874.874,0,0,0,.646.273.877.877,0,0,0,.653-.273l6.284-6.277a.908.908,0,0,0,.268-.652v-3.834a.572.572,0,0,0-.572-.578h-3.839A.9.9,0,0,0-15392.158-24789.434Zm1.574,2.047a1.173,1.173,0,0,1,1.17-1.17,1.169,1.169,0,0,1,1.169,1.17,1.172,1.172,0,0,1-1.169,1.17A1.176,1.176,0,0,1-15390.584-24787.387Z",
    transform: "translate(6685.9 34766.898)",
    fill: "#fd581f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTagSelected);
export default __webpack_public_path__ + "static/media/filter_tag_selected.ab364b4b0606aa2b3307991e290e929d.svg";
export { ForwardRef as ReactComponent };